import { Collapsible } from '@cma/common'
import {
  building_condo as BuildingIcon,
  building_modern as BuildingModernIcon,
  shared as GroupIcon
} from '@helix/helix-icon/outlined'
import AdminBrandDetails from './AdminBrandDetails'
import { useBrandHub, SelectedEntity, BrandableType } from './BrandHubContext'
import { Brokerage, Office } from '../../../../generated/graphql'

export default function AdminHierarchyTree() {
  const {
    platformClient,
    selectedEntity,
    setSelectedEntity,
    setShowAddBrandForm
  } = useBrandHub()

  const handleEntitySelect = (entity: SelectedEntity) => {
    setSelectedEntity(entity)
    setShowAddBrandForm(false)
  }

  const getTeamsByOffice = (officeId: string) => {
    return (
      platformClient?.teams?.filter(
        (team) => team?.primaryOfficeId === officeId
      ) || []
    )
  }

  const isSelected = (
    entityId: string,
    brandableType: BrandableType,
    brokerageId?: string
  ): boolean => {
    return (
      selectedEntity.id === entityId &&
      selectedEntity.brandableType === brandableType &&
      selectedEntity.brokerageId === brokerageId
    )
  }

  return (
    <div className="flex h-full">
      <div className="mt-2 w-full max-w-[259px] flex-shrink-0">
        <Collapsible>
          <Collapsible.Item
            defaultOpen
            collapsible={
              !!(
                (platformClient?.brokerages &&
                  platformClient.brokerages.length > 0) ||
                (platformClient?.offices?.filter(
                  (office: Office) => !office.brokerageId
                )?.length ?? 0) > 0
              )
            }
            icon={BuildingIcon}
            triggerLabel={platformClient?.platformAccountName || ''}
            selected={isSelected(platformClient?.id || '', 'Account')}
            onClick={() => {
              if (platformClient) {
                handleEntitySelect({
                  id: platformClient.id,
                  name: platformClient.platformAccountName || '',
                  usersCount: platformClient.usersCount || 0,
                  brandableType: 'Account',
                  displayAddress: ''
                })
              }
            }}>
            {platformClient?.brokerages?.map((brokerage: Brokerage) => (
              <Collapsible.Item
                key={brokerage.id}
                collapsible={
                  !!(brokerage.offices && brokerage.offices.length > 0)
                }
                icon={BuildingIcon}
                triggerLabel={brokerage?.name || ''}
                selected={isSelected(brokerage.id, 'Brokerage')}
                onClick={() =>
                  handleEntitySelect({
                    id: brokerage.id,
                    name: brokerage?.name || '',
                    usersCount: brokerage.usersCount || 0,
                    brandableType: 'Brokerage',
                    displayAddress: brokerage.displayAddress || ''
                  })
                }>
                {brokerage.offices?.map((office: Office) => (
                  <Collapsible.Item
                    key={`${office.id}_${brokerage.id}`}
                    collapsible={getTeamsByOffice(office.id).length > 0}
                    icon={BuildingModernIcon}
                    triggerLabel={office?.name || ''}
                    selected={isSelected(office.id, 'Office', brokerage.id)}
                    onClick={() =>
                      handleEntitySelect({
                        id: office.id,
                        name: office?.name || '',
                        usersCount: office.usersCount || 0,
                        brokerageId: brokerage.id,
                        brandableType: 'Office',
                        displayAddress: office.displayAddress || ''
                      })
                    }>
                    {platformClient?.teams
                      ?.filter((team) => team?.primaryOfficeId === office.id)
                      .map((team) => (
                        <Collapsible.Item
                          key={`team_${team.id}_${office.id}`}
                          collapsible={false}
                          icon={GroupIcon}
                          triggerLabel={team?.name || ''}
                          selected={isSelected(team.id, 'Team', brokerage.id)}
                          onClick={() =>
                            handleEntitySelect({
                              id: team.id,
                              name: team?.name || '',
                              usersCount: team.usersCount || 0,
                              brandableType: 'Team',
                              displayAddress: office.displayAddress || ''
                            })
                          }>
                          {null}
                        </Collapsible.Item>
                      ))}
                  </Collapsible.Item>
                ))}
              </Collapsible.Item>
            ))}
            {platformClient?.offices
              ?.filter((office: Office) => !office.brokerageId)
              .map((office: Office) => (
                <Collapsible.Item
                  key={`${office.id}_independent`}
                  collapsible={getTeamsByOffice(office.id).length > 0}
                  icon={BuildingModernIcon}
                  triggerLabel={office?.name || ''}
                  selected={isSelected(office.id, 'Office')}
                  onClick={() =>
                    handleEntitySelect({
                      id: office.id,
                      name: office?.name || '',
                      usersCount: office.usersCount || 0,
                      brandableType: 'Office',
                      displayAddress: office.displayAddress || ''
                    })
                  }>
                  {platformClient?.teams
                    ?.filter((team) => team?.primaryOfficeId === office.id)
                    .map((team) => (
                      <Collapsible.Item
                        key={`team_${team.id}_${office.id}`}
                        collapsible={false}
                        icon={GroupIcon}
                        triggerLabel={team?.name || ''}
                        selected={isSelected(team.id, 'Team')}
                        onClick={() =>
                          handleEntitySelect({
                            id: team.id,
                            name: team?.name || '',
                            usersCount: team.usersCount || 0,
                            brandableType: 'Team',
                            displayAddress: office.displayAddress || ''
                          })
                        }>
                        {null}
                      </Collapsible.Item>
                    ))}
                </Collapsible.Item>
              ))}
          </Collapsible.Item>
        </Collapsible>
      </div>
      <div className="flex flex-1 border-l border-gray-200 pl-6">
        <AdminBrandDetails />
      </div>
    </div>
  )
}
